import ButtonB from "../elements/ButtonB";
import Card from "../elements/Card";
import style from "./Projects.module.css";
import lpdnc from "../../images/projects/lpdnc.svg";
import CCXP from "../../images/projects/CCXP.jpg";

const Projects = () => {
  return (
    <div className={style.projects} id="projects">
      <h1>Projetos</h1>
      
      <Card 
        img={lpdnc}
        title="LP - DNC"
        technology="HTML, CSS e JS"
        description="Desenvolvimento de uma landing page"
        site="https://landingpagedesafiobase.netlify.app/"
        repo="https://github.com/EmersonAvilaDev/desafio-landingPage"
      />

      <Card
        img={CCXP}
        title="CCXP_project"
        technology="HTML, CSS e JS"
        description="Desenvolvimento da pagina do Evento CCXP"
        site="https://lucky-paprenjak-aae57f.netlify.app/"
        repo="https://github.com/EmersonAvilaDev/CCXP_project"
      />
      <ButtonB
        text="Ver mais projetos"
        link="https://github.com/EmersonAvilaDev?tab=repositories"
      />
    </div>
  );
};

export default Projects;
